import React from 'react';
import { Icon, Label } from '@nooz-optics/nooz-components-lib';
import { Link } from '../../../../Elements/Link';
import { formatContentfulComponentProps } from '../../../../../../utils/globals';
import { List } from '../../../../Navigation/List/list';

export interface HeaderActionHelpProps {
  details: IBlock;
  actions: IBlock;
}

export const ActionHelp = ({ link, body }) => (
  <div className='relative flex transition justify-between w-full'>
    <Link {...link}>
      <div className='flex items-center'>
        <Icon
          {...link.icon}
          size='xl'
          color={{ classname: 'gray-700' }}
        />
        <div className='ml-4'>
          <Label
            {...link.label}
            color={{ classname: 'gray-800' }}
            size='lg'
            weight='medium'
          />
          <Label
            {...body}
            size='base'
            weight='light'
          />
        </div>
      </div>
    </Link>
  </div>
);

export const HeaderActionHelp = ({ details, actions }) => (
  <div className='rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 overflow-scroll no-scrollbar'>
    <div className='p-5 py-2'>
      <List
        divide
        listItems={details?.items.map((item) => ({
          spacing: 'py-3',
          children: <ActionHelp {...formatContentfulComponentProps(item)} />,
        }))}
      />
    </div>

    <div className='p-5 bg-gray-200 space-y-6 sm:flex sm:space-y-0 sm:space-x-10'>
      {actions?.items.map((item) => {
        const { link } = formatContentfulComponentProps(item);
        return (
          <div className='p-1 flex items-center rounded-md text-base font-medium text-gray-900 hover:bg-gray-100 transition ease-in-out duration-150'>
            <Link {...link}>
              <div className='flex justify-center items-center'>
                <div className='rounded-md overflow-hidden'>
                  <Icon
                    {...link.icon}
                    size='xl'
                    color={{ classname: 'primary' }}
                  />
                </div>
                <div className='ml-4'>
                  <Label
                    {...link.label}
                    size='base'
                    weight='bold'
                  />
                </div>
              </div>
            </Link>
          </div>
        );
      })}
    </div>
  </div>
);
